import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BalanceAmount from '@swf/components/CurrencyAmount/BalanceAmount';
import Translation from '@swf/components/Translation/Translation';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import useTrackers from '@swf/core/hooks/useTrackers';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import { Icon } from '@swf/sports/components';

import ElementWithCount from '../../../../../ElementWithCount/ElementWithCount';

import { TXTWCL_Account_22, TXTWCL_Bet_Slip } from './OpenMobileBetSlipHeaderContent.messages.json';
import styles from './OpenMobileBetSlipHeaderContent.scss';

const OpenMobileBetSlipHeaderContent: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { formatMessage } = useRegulatoryIntl();
  const selectionsCount = useSelector(select.betSlip.selectionsCount);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const isAndroid = useSelector(select.device.isAndroid);
  const { showBalance } = useSelector(select.localSettings.get);
  const playChips = useSelector(select.account.getPlayChips);
  const totalBalance = useSelector(select.account.getTotalBalance);
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const balance = isPlayMoney ? playChips : totalBalance;
  const { buttonPressed } = useTrackers();

  if (isEmbedded && isAndroid) {
    return (
      <ElementWithCount count={selectionsCount} element={<Translation {...TXTWCL_Bet_Slip} />} />
    );
  }

  return (
    <>
      <button
        type="button"
        aria-label={formatMessage(TXTWCL_Account_22)}
        className={styles.button}
        onClick={() => {
          buttonPressed({ buttonName: 'Account' });
          modal.enqueue({ path: '/account' });
        }}
      >
        <Icon name="account" size="xl" />
      </button>

      {showBalance && (
        <button
          type="button"
          className={styles.button}
          onClick={() => {
            buttonPressed({ buttonName: 'Balance' });
            modal.enqueue({ path: `/account/cashier/${isPlayMoney ? 'playmoney' : 'home'}` });
          }}
        >
          <BalanceAmount value={balance as number} />
        </button>
      )}
    </>
  );
};

export default OpenMobileBetSlipHeaderContent;
